/**
 * 退回钱包记录 (原退款确认)
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import {Tabs, Spin, Tooltip, Modal,message } from "antd";
import PageCommon from  "@components/PageCommon/PageCommon";
import {symbolMoneyUtil} from '@utils/utils';
import {Link} from "react-router-dom";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import dayjs from 'dayjs';
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import IconDirectPo from "@components/Icon/IconDirectPo/IconDirectPo";//直达图标
import "./index.less";
import FnanceAction from "../Fnance.action";
// import BtnRefundConfirmation  from "./BtnRefundConfirmation";
class RefundConfirmation extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchFormOptionsOne:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'poCode',
                    cnTitle:'订单编号',
                    cnTitleId:'GuanLianDanHao',
                    cnPlaceholder:'订单编号',
                    cnPlaceholderId:'GuanLianDanHao',
                    hiddenLabel:true,
                    width:220,
                },
                {
                    name:'keyword',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    cnPlaceholder:'请输入客户编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng',
                    hiddenLabel:true,
                },
            ],
            searchFormOptionsTwo:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'poCode',
                    cnTitle:'订单编号',
                    cnTitleId:'GuanLianDanHao',
                    cnPlaceholder:'订单编号',
                    cnPlaceholderId:'GuanLianDanHao',
                    hiddenLabel:true,
                    width:220,
                },
                {
                    name:'keyword',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    cnPlaceholder:'请输入客户编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng',
                    hiddenLabel:true,
                },
            ],
            columns:[
                {
                    cnTitle: '订单信息',
                    cnTitleId: 'DingDanXinXi',
                    dataIndex: 'poCode',
                    width:220,
                    render:(poCode, record, index) => (<>
                        <p>
                            <Link to={`/order/sale/detail?id=${record.poId}`} className={"fw_700 black89"} target={"_blank"}>
                            {/*<ModalOrderDetail id={record.poId}>*/}
                                {record.noCertificateSplit==1?<Tooltip title={__getServerLanguage('ZhongGuoZhiFaDingDan')}><span className={"ml_4"}>
                                            <IconDirectPo size={18}></IconDirectPo>
                                        </span>
                                </Tooltip>:null} <span className={"fw_700 black89 cursor-p"}>{poCode}</span>
                            {/*</ModalOrderDetail>*/}
                            </Link>
                        </p>
                        {record.containerCode&&<div>
                            <LogisticsAndCabinetSwitch poId = {record.poId}
                                                       poCode={record.poCode}
                                                       containerCode={record.containerCode}
                                                       cabinetNum={record.cabinetNum}
                            />
                        </div>}
                    </>)
                },
                {
                    cnTitle: '客户',
                    cnTitleId: 'KeHu',
                    dataIndex: 'buyerCode',
                    render:(text, record, index) => (<>
                        <Link className="font-main2" to={`/customer/detail?id=${record.buyerId}`} target={"_blank"}>{record.buyerCode}</Link>
                    </>),
                    width:150,
                },
                {
                    cnTitle: '商品',
                    cnTitleId: 'ShangPin',
                    dataIndex: 'skuNo',
                    width:150,
                    render: (skuNo, record) => {
                        return(<div className={"ellipsis-line2 black66 fw_500"} title={skuNo}>
                            {skuNo}
                        </div>)},
                },
                {
                    cnTitle: '类型',
                    cnTitleId: 'LeiXing',
                    dataIndex: 'typeName',
                    render: (typeName, record) => {
                        return(<span className={"black66"}>
                            {typeName}
                        </span>)},
                    width:150,
                },
                {
                    cnTitle: '退款金额',
                    dataIndex: 'cancelRefundTotal',
                    cnTitleId: 'TuiKuanJinE',
                    render:(text, record, index) => (<div>
                        <p className={"fw_500"}>
                            {record.priceTotal?symbolMoneyUtil(record.priceTotal, record.currencySymbol):'-'}
                        </p>
                        <p className={"black45"}>
                            <Tooltip placement="right" title={Lang({id:"TuiKuanChanShengShiJian", default:"退款产生时间"})}>
                                <span className={"ri-time-line"} />
                                <span className={"font_12 ml_4"}>{record.createTime? dayjs(record.createTime).format("YYYY-MM-DD"): "-"}</span>
                            </Tooltip>
                        </p>
                        {record.days&&record.days>0?<p className={"color-err font_12"}>{Lang({id:"YiGuoNTian",default:`已过 ${record.days} 天`,params:[record.days]})}</p>:null}
                    </div>),
                    width:150,
                },
                // {
                //     cnTitle: '状态³',
                //     cnTitleId: 'ZhuangTai',
                //     dataIndex: 'statusName',
                //     render:(statusName, record, index) => (<>
                //         <div className="black45 labelStatus">{statusName}</div>
                //     </>)
                // },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                    width:150,
                    render: (transitCityName, record) => {
                        return(<span>
                         <i className="black45 ri-building-line mr_4"></i>{transitCityName}
                        </span>)},

                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 150,
                    fixed:'right',
                    // align:"right",
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => ( <>
                        {/*<BtnRefundConfirmation row={record} refreshPage={()=>this.refreshPage()}/>*/}
                        <span className={"btnConf"} onClick={()=>this.handleConf(record)}>{Lang({id:"ChaKanQueRen",default:"查看确认"})}</span>
                   </> ) },
            ],
            columnsReviewed:[
                {
                    cnTitle: '订单信息',
                    cnTitleId: 'DingDanXinXi',
                    dataIndex: 'poCode',
                    width:250,
                    render:(poCode, record, index) => (<>
                        <p>
                            {/*<ModalOrderDetail id={record.poId}>*/}
                            <Link to={`/order/sale/detail?id=${record.poId}`} className={"fw_700 black89"} target={"_blank"}>
                                {record.noCertificateSplit==1?<Tooltip title={__getServerLanguage('ZhongGuoZhiFaDingDan')}><span className={"ml_4"}>
                                            <IconDirectPo size={18}></IconDirectPo>
                                        </span>
                                </Tooltip>:null} <span className={"fw_700 black89 cursor-p"}>{poCode}</span>
                            </Link>
                            {/*</ModalOrderDetail>*/}
                        </p>
                        {record.containerCode&&<div>
                            <LogisticsAndCabinetSwitch poId = {record.poId}
                                                       poCode={record.poCode}
                                                       containerCode={record.containerCode}
                                                       cabinetNum={record.cabinetNum}
                            />
                        </div>}
                    </>)
                },
                {
                    cnTitle: '客户',
                    cnTitleId: 'KeHu',
                    dataIndex: 'buyerCode',
                    render:(text, record, index) => (<>
                        <Link className="font-main2" to={`/customer/detail?id=${record.buyerId}`} target={"_blank"}>{record.buyerCode}</Link>
                    </>),
                    width:150,
                },
                {
                    cnTitle: '商品',
                    cnTitleId: 'ShangPin',
                    dataIndex: 'skuNo',
                    width:200,
                    render: (skuNo, record) => {
                        return(<div className={"black66 fw_500"} title={skuNo}>
                            {skuNo}
                        </div>)},
                },
                {
                    cnTitle: '类型',
                    cnTitleId: 'LeiXing',
                    dataIndex: 'typeName',
                    render: (typeName, record) => {
                        return(<span className={"fw_500"}>
                            {typeName}
                        </span>)},
                    width:100,
                },
                {
                    cnTitle: '退款金额',
                    dataIndex: 'cancelRefundTotal',
                    cnTitleId: 'TuiKuanJinE',
                    render:(text, record, index) => (<div>
                        <p className={"fw_500"}>
                            {record.priceTotal?symbolMoneyUtil(record.priceTotal, record.currencySymbol):'-'}
                        </p>
                    </div>),
                    width:150,
                },
                // {
                //     cnTitle: '状态³',
                //     cnTitleId: 'ZhuangTai',
                //     dataIndex: 'statusName',
                //     render:(statusName, record, index) => (<>
                //         <div className="black45 labelStatus labelStatusGreen">{statusName}</div>
                //         <div className={"mt_10"}>{record.refundTypeName}</div>
                //     </>)
                // },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                    width:150,
                    render: (transitCityName, record) => {
                        return(<span>
                         <i className="black45 ri-building-line mr_4"></i>{transitCityName}
                        </span>)},

                },
                {
                    cnTitle: '确认信息',
                    cnTitleId: 'QueRenXinXi',
                    width: 190,
                    render: (item = {}, record) => (<div>
                        <p className={"fw_500"}>
                            {record.handlerName||'-'}
                        </p>
                        <p className={"black66 font_12"}>
                            {record.handlerTime? dayjs(record.handlerTime).format("YYYY-MM-DD"): "-"}
                        </p>
                    </div>)
                },
            ],
            auditStatus:'1',//默认 1:进行中 2:已完成
            total: 0,
            selectSeven:false, //是否勾选 7天

        }
    }
    /**
     * 查看确认
     **/
    handleConf(row){
        Modal.confirm({
            title:Lang({id:'TiShi',default:'提示'}),
            content: Lang({id:'QingQueRenZaiCaiWuXiTongZ',default:'请确认在财务系统中已经完成处理'}),
            icon: null,
            okText:Lang({id:'QueDing',default:'确定'}),
            cancelText:Lang({id:'QuXiao',default:'取消'}),
            okButtonProps: {
                style: {
                    backgroundColor: '#A4373A',
                    borderColor: '#A4373A'
                }
            },
            onOk: () => {
                const postData = {
                    id: row.id,
                    type: 10,
                }
                this.loading(true);
                FnanceAction.updateRefundConfirm(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
            },
            onCancel: () => {
                // 用户取消，不执行任何操作
            }
        });

    }
    handleRes(response={}){
        this.loading(false);
        if (response.success && response.valid) {
            message.open({
                type: 'success',
                content: Lang({id: 'CaoZuoChengGong', default: '操作成功'}),
            });
            // 刷新 页面数据
            setTimeout(()=>{
                this.refreshPage();
            },200)
        }else{
            message.open({
                type: 'warning',
                content:response.message|| Lang({id: 'CaoZuoShiBai',default:'操作失败'}),
            });
        }
    }
    /**
     * 改变状态
     **/
    changeTab(activeKey){
        this.setState({
            auditStatus:activeKey
        },()=>{
            switch (activeKey) { // 已加载组件 更新点击项 时 重新搜索内容
                case '2':
                    if(this.onRefTabChildTwo){
                        this.onRefTabChildTwo.handleFetch(1,{},true);
                    }
                    break
                default:
                    if(this.onRefTabChildOne){
                        this.onRefTabChildOne.handleFetch(1,{},true);
                    }
            }
        })
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    onRefTabTwo = (ref) =>  this.onRefTabChildTwo = ref;
    fetchCallBack(res={}){
        const { success, valid,paging={}} = res;
        if(success&&valid&&paging.pageNum){
            this.setState({
                oneTabPageNum:paging.pageNum
            })
        }
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;

    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    refreshPage(){
        const { oneTabPageNum=1} = this.state;
        this.onRefTabChildOne.handleFetch(oneTabPageNum,{},true);

    }
    componentDidMount() {}
    componentWillMount() {

    }
    render(){
        const { loading,searchFormOptionsOne,columns,auditStatus,columnsReviewed, searchFormOptionsTwo, } = this.state;
        const currPageName = Lang({id: "TuiHuiQianBaoJiLu",default: "退回钱包记录"});
        return (<PageCommon onRef={this.onRefPageCommon}>
            <Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className="refundConfirmationWrap">
                    <Tabs defaultActiveKey={auditStatus}
                          onChange={(activeKey)=>this.changeTab(activeKey)}
                          items={[
                              {
                                  key: '1',
                                  label:Lang({id: 'WeiQueRen', default: '未确认'}),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columns}
                                                      fetchCallBack={(data)=>this.fetchCallBack(data)}
                                                      onRef={this.onRefTabOne}
                                                      pageSize={50}
                                                      searchFormOptions={searchFormOptionsOne}
                                                      precondition={{
                                                          type: 0, // 列表类型 0:待确认 1;已确认
                                                      }}
                                                      scroll={{x:1150,}}
                                                      fetchApi={'/service/mg/sale/cancel/refund/item'}>
                                      </AutoFetchTable>
                                  </div>)
                              },{
                                  key: '2',
                                  label:Lang({id: 'YiQueRen', default: '已确认'}),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columnsReviewed}
                                                      onRef={this.onRefTabTwo}
                                                      searchFormOptions={searchFormOptionsTwo}
                                                      pageSize={50}
                                                      scroll={{x:1250,}}
                                                      precondition={{
                                                          type: 1,// 列表类型 0:待确认 1;已确认
                                                      }}
                                                      fetchApi={'/service/mg/sale/cancel/refund/item'}  />
                                  </div>)
                              }
                          ]}
                    >
                    </Tabs>
                </div>
            </Spin>
        </PageCommon> )
    }
}

export default RefundConfirmation;
